import React from 'react'
import { connect } from 'react-redux'

const formatDate = (date) => {
  date = date.split('-')
  return `${date[1]}-${date[2]}-${date[0]}`
}

const ProjectDeliverable = (props) => {
  const { deliverable, history } = props

  return (
    <tr
      id="ProjectListItem"
      className={deliverable.status.toLowerCase().replace(" ","-")}
      style={{verticalAlign:"middle"}}
      onClick={() => history.push(`/projects/${deliverable.project.id}/deliverables`)}
      >
      <td>
      {deliverable.project.short_id}-{deliverable.project.number} - {deliverable.project.title}
      </td>
      <td>
        {deliverable.name}
      </td>
      <td>
        {deliverable.status}
      </td>
      <td>
        {deliverable.due_date ? formatDate(deliverable.due_date) : ''}
      </td>
    </tr>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(ProjectDeliverable);



// WEBPACK FOOTER //
// ./src/routes/projects/components/ProjectDeliverable.js